// types
import { BreadCrumbs } from 'shared/types/breadCrumbs';

// helpers
import { getDomainConfig } from 'shared/domainConfig/helpers';

export const getPlpJSONLD = (products: { products: Listing.IProduct[] }) => {
  const { SHARE } = getDomainConfig();
  return JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    itemListElement: [
      products.map((product: Record<string, string>, index: number) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: product.title + ' ' + product.subTitle,
          url: SHARE.CANONICAL_HOMEPAGE_URL + (product.actionUrl || product.action_url),
        };
      }),
    ],
  });
};

export const getBreadCrumbsData = (breadCrumbs: BreadCrumbs) => {
  if (!breadCrumbs.length) return;

  const data = { breadCrumbs: {} };
  const { SHARE } = getDomainConfig();

  const breadCrumbList = breadCrumbs.map((crumb, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: crumb?.key,
      item: `${SHARE.CANONICAL_HOMEPAGE_URL}${crumb?.value}`,
    };
  });

  data.breadCrumbs = {
    '@type': 'BreadcrumbList',
    itemListElement: breadCrumbList,
  };

  return data;
};
